"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BytehogsAPI = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _axios = _interopRequireDefault(require("axios"));

var BytehogsAPI = function BytehogsAPI(SERVICE, ENDPOINT, inputData, STAGE) {
  var fullSource = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var noTokenRefresh = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return new Promise(function (resolve, reject) {
    var data = fullSource ? (0, _objectSpread2.default)({}, inputData) : JSON.stringify((0, _objectSpread2.default)({}, inputData));

    _axios.default.post(fullSource ? fullSource : "https://".concat(STAGE, ".bytehogs.com/").concat(SERVICE, "/").concat(ENDPOINT), data).then(function (response) {
      resolve(response);
    }).catch( /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(error) {
        var sessionToken, refreshToken;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(error.response && error.response.status === 401 && !noTokenRefresh)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 3;
                return localStorage.getItem('sToken');

              case 3:
                sessionToken = _context2.sent;
                _context2.next = 6;
                return localStorage.getItem('rToken');

              case 6:
                refreshToken = _context2.sent;

                _axios.default.post("https://".concat(STAGE, ".bytehogs.com/").concat(SERVICE, "/token"), JSON.stringify({
                  sessionToken: sessionToken,
                  refreshToken: refreshToken,
                  operation: "refresh"
                })).then( /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(response) {
                    var resp;
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            data = fullSource ? (0, _objectSpread2.default)((0, _objectSpread2.default)({}, inputData), {}, {
                              sessionToken: response.data.sessionToken
                            }) : JSON.stringify((0, _objectSpread2.default)((0, _objectSpread2.default)({}, inputData), {}, {
                              sessionToken: response.data.sessionToken
                            }));
                            _context.next = 3;
                            return localStorage.setItem("sToken", response.data.sessionToken);

                          case 3:
                            _context.next = 5;
                            return _axios.default.post(fullSource ? fullSource : "https://".concat(STAGE, ".bytehogs.com/").concat(SERVICE, "/").concat(ENDPOINT), data);

                          case 5:
                            resp = _context.sent;
                            resolve(resp);

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  console.log(err.response);
                  reject(err.response || err);
                });

                _context2.next = 11;
                break;

              case 10:
                reject(error.response || error);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
};

exports.BytehogsAPI = BytehogsAPI;